.separator {
  /* Horizontal (default) */
  border-bottom: var(--spaces-1) solid var(--vapor-separator-color);
  margin-bottom: var(--vapor-separator-gap);
  padding-bottom: var(--vapor-separator-gap);

  /* Vertical variant */
  &:where([data-vertical]) {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
    border-left: var(--spaces-1) solid var(--vapor-separator-color);
    height: var(--vapor-separator-height, auto);
    margin-left: var(--vapor-separator-gap);
    padding-left: var(--vapor-separator-gap);
  }

  /* Stretch */
  &:where([data-stretch]) {
    align-self: stretch;
  }
}
